export default "__VITE_ASSET__CCRXpvw9__"